module.exports = __webpack_public_path__ + "img/icon-good-round@2x.c6e4c0e1.png";